import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class PartnerSignupService {
  constructor(private http: HttpClient) {}

  getDriveKey = () => environment.partnerSignUp.driveAppKey;
  getAppKey = () => environment.partnerSignUp.appKey;
  getDriveURL = () => environment.partnerSignUp.driveURL;
  getAppURL = () => environment.partnerSignUp.appURL;

  getCompanyEntities = async () => {
    return await this.http
      .get<any>(
        `${environment.partnerSignUp.partnerURL}/types/company-entities`,
        {
          headers: new HttpHeaders().append(
            'app-key',
            environment.partnerSignUp.partnerKey
          ),
        }
      )
      .toPromise();
  };

  getECommercePlatforms = async () => {
    return await this.http
      .get<any>(
        `${environment.partnerSignUp.partnerURL}/types/ecommerce-platforms`,
        {
          headers: new HttpHeaders().append(
            'app-key',
            environment.partnerSignUp.partnerKey
          ),
        }
      )
      .toPromise();
  };
}
